module.exports = __webpack_public_path__ + "88f2193ba6748f0081265e6186d3776e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-14.png
// module id = 2454
// module chunks = 0